// material-ui
import {} from '@mui/material'

// assets

import PlaywatchGoMobile from 'components/PlaywatchGoMobile'

// ================================|| UI LIST - SIMPLE LIST ||================================ //

export default function SimpleList() {
  // Generate Grid

  function main(subcomponent: any): any {
    return (() => {
      return <PlaywatchGoMobile />
    })()
  }

  let output_main = main(null)

  return output_main
}
